export const OPEN_LOADING = 'LOADING/OPEN';
export const CLOSE_LOADING = 'LOADING/CLOSE';
export const OPEN_LOADING_SUCCESS = 'LOADING/OPEN_LOADING_SUCCESS';
